var map = {
	"./NotFoundPage.jpg": 6436,
	"./aqupe-logo.svg": 124,
	"./aqupe-min-logo.png": 6456,
	"./cel1.png": 7892,
	"./default/no-icon.png": 7564,
	"./default/no-image.png": 9916,
	"./error-foto.png": 2420,
	"./example_plin01.jpg": 9196,
	"./example_yape01.jpg": 12,
	"./example_yape02.jpg": 7124,
	"./imagen_tienda.jpg": 6152,
	"./loading.png": 4172,
	"./logo-mastercard.svg": 5816,
	"./logo-pagoefectivo.svg": 320,
	"./logo-plin.svg": 820,
	"./logo-visa.svg": 1440,
	"./logo-yape.svg": 484,
	"./mastercard-logo.png": 9920,
	"./max-logo.png": 5840,
	"./plin-logo.png": 5276,
	"./portada.jpg": 612,
	"./product-not-found.png": 8508,
	"./products/celular.png": 8500,
	"./products/chaqueta.png": 7524,
	"./products/tv.png": 4156,
	"./profile-default.png": 5356,
	"./profile.jpg": 2024,
	"./shop-default.png": 2216,
	"./slider-categories/alimentos-y-bebidas.jpg": 1464,
	"./slider-categories/automotriz.jpg": 4112,
	"./slider-categories/belleza-y-cuidado-personal.jpg": 4180,
	"./slider-categories/deportes-y-entretenimiento.jpg": 4812,
	"./slider-categories/electronica.jpg": 1156,
	"./slider-categories/electronicos-para-el-hogar.jpg": 2432,
	"./slider-categories/hogar-y-jardin.jpg": 8364,
	"./slider-categories/juguetes-y-pasatiempos.jpg": 8624,
	"./slider-categories/moda.jpg": 5804,
	"./slider-categories/salud-y-cuidado-personal.jpg": 2476,
	"./slider/slider1.jpg": 4476,
	"./slider/slider2.jpg": 9164,
	"./slider/slider3.jpg": 2260,
	"./user.svg": 4692,
	"./visa-logo.png": 3092,
	"./yape-logo.png": 844
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 372;